{/*import React from "react";
import "../styles/Landingpage.css";
import {
    FaBell,
    FaBriefcase,
    FaGraduationCap,
    FaPlay,
    FaArrowRight
} from "react-icons/fa";

const LandingPage = () => {
    return (
        <div className="landing-container">

            {/* NAVBAR 
            <nav className="navbar fade-down">
                <div className="nav-left">
                    <img src="/logo.png" alt="StrideNext Logo" className="logo" />
                    <h2 className="brand-name">StrideNext</h2>
                </div>

                <ul className="nav-links">
                    <li>Home</li>
                    <li>Students</li>
                    <li>Employers</li>
                    <li>Trainers</li>
                    <li>Jobs</li>
                    <li>Courses</li>
                    <li>Assessments</li>
                </ul>

                <div className="nav-auth">
                    <button className="signin-btn">Sign In</button>
                    <button className="signup-btn">Sign Up</button>
                </div>
            </nav>

            {/* LAUNCHING BANNER 
            <div className="launch-banner fade-up">
                <div>
                    <span className="coming-soon">🚀 Launching Soon</span>
                    <h3>StrideNext is launching soon!</h3>
                    <p>Be the first to know when we go live. Join early for exclusive access.</p>
                </div>

                <div className="notify-box">
                    <input type="email" placeholder="Enter your email" />
                    <button className="notify-btn">
                        <FaBell size={14} /> Notify Me
                    </button>
                </div>
            </div>

            {/* HERO SECTION 
            <section className="hero">
                <div className="hero-left fade-left">
                    <h1>
                        Your Gateway to <br />
                        <span className="highlight">Career Success</span>
                    </h1>

                    <p className="hero-desc">
                        Connecting students with opportunities, helping employers discover
                        top talent, and empowering trainers to build the future workforce.
                    </p>

                    <div className="hero-buttons">
                        <button className="primary-btn">🚀 Get Started Free</button>
                        <button className="secondary-btn">
                            <FaPlay size={13} /> How It Works
                        </button>
                    </div>
                </div>

                <div className="hero-right fade-right">
                    <div className="dashboard-card">
                        <h4>Dashboard</h4>

                        <div className="dash-item">
                            <div className="icon blue"><FaBriefcase /></div>
                            <div>
                                <p className="dash-title">12 Job Applications</p>
                                <span>3 Interviews Scheduled</span>
                            </div>
                        </div>

                        <div className="dash-item">
                            <div className="icon green"><FaGraduationCap /></div>
                            <div>
                                <p className="dash-title">5 Courses Completed</p>
                                <span>2 Certificates Earned</span>
                            </div>
                        </div>
                    </div>
                </div>
            </section>

            {/* FOOTER 
            <footer className="footer fade-up">
                <div className="footer-top">
                    <h2 className="footer-title">Start Your Journey Today</h2>
                    <p>Join thousands of learners and employers shaping the future.</p>
                    <button className="footer-btn">
                        Get Started <FaArrowRight />
                    </button>
                </div>

                <div className="footer-bottom">
                    <p>© 2025 StrideNext. All Rights Reserved.</p>
                </div>
            </footer>

        </div>
    );
};

export default LandingPage; 

*/}



import React, { useState } from "react";
import "../styles/Landingpage.css";
import {
    FaBell,
    FaPlay,
    FaArrowRight,
    FaBolt,
    FaRocket,
    FaBars,
    FaTimes,
    FaUsers,
    FaBriefcase,
    FaCertificate
} from "react-icons/fa";
import { useNavigate } from "react-router-dom";


import logo from "../assets/StrideNext02.png"; // FIXED LOGO PATH

const COMMON_MODULE_URL = "https://auth.stridenext.in";

const handleSignIn = () => {
    window.location.href = `${COMMON_MODULE_URL}/signin?redirect=${window.location.origin}/auth/callback`;
};

const handleSignUp = () => {
    window.location.href = `${COMMON_MODULE_URL}/signup?redirect=${window.location.origin}/auth/callback`;
};

const LandingPage = () => {

    const [menuOpen, setMenuOpen] = useState(false);
    const [message, setMessage] = useState("");
    const [submitted, setSubmitted] = useState(false);
    const [showSuccess, setShowSuccess] = useState(false);

    const handleNotify = (e) => {
        e.preventDefault();
        const email = e.target.email.value;
        console.log("Email submitted:", email);
        setSubmitted(true);
    };


    const goToLogin = () => {
        window.location.href = "https://auth.stridenext.in/signin?redirect=http://localhost:3001/auth/callback";
    };





    return (
        <div className="page-container">

            {/* NAVBAR */}
            <nav className="navbar">
                <div className="nav-left">
                    <img src={logo} alt="StrideNext Logo" className="logo" />
                    <h2 className="brand-name">StrideNext</h2>
                </div>

                <ul className={`nav-links ${menuOpen ? "mobile-nav-open" : ""}`}>
                    <li>Home</li>
                    <li>Students</li>
                    <li>Employers</li>
                    <li>Trainers</li>
                    <li>Jobs</li>
                    <li>Courses</li>
                    <li>Assessments</li>

                    {/* Mobile Buttons */}
                    <div className="mobile-auth">
                        <button className="signin-btn" onClick={handleSignIn}>Sign In</button>
                        <button className="signup-btn" onClick={handleSignUp}>Sign Up</button>
                    </div>
                </ul>

                <div className="nav-auth">
                    <button className="signin-btn" onClick={handleSignIn}>Sign In</button>
                    <button className="signup-btn" onClick={handleSignUp}>Sign Up</button>
                </div>

                {/* MOBILE MENU ICON */}
                <div className="mobile-menu-icon" onClick={() => setMenuOpen(!menuOpen)}>
                    {menuOpen ? <FaTimes size={22} /> : <FaBars size={22} />}
                </div>
            </nav>





            {/* LAUNCH BANNER */}
            {!submitted && (
                <div className="launch-banner fade-up">
                    <div>
                        <span className="coming-badge"><FaBolt /> Launching Soon</span>
                        <h3 className="launch-title">StrideNext is launching soon!</h3>
                        <p className="launch-desc">
                            Be the first to know when we go live. Join early for exclusive access.
                        </p>
                    </div>

                    <form className="notify-box" onSubmit={handleNotify}>
                        <input type="email" name="email" placeholder="Enter your email" required />
                        <button className="notify-btn" type="submit">
                            <FaBell size={14} /> Notify Me
                        </button>
                    </form>
                </div>
            )}

            {/* SUCCESS MESSAGE */}
            {showSuccess && (
                <div className="success-container">
                    <p className="success-message">
                        🎉 <strong>You're on the list!</strong> Thank you for subscribing.
                        You'll be notified as soon as we launch.
                    </p>
                </div>
            )}





            {/* HERO */}
            <section className="hero fade-left">
                <div className="hero-left">
                    <h1 className="hero-title">
                        Your Gateway to <br />
                        <span className="highlight">Career Success</span>
                    </h1>

                    <p className="hero-desc">
                        Connecting students with opportunities, helping employers discover
                        top talent, and empowering trainers to build the future workforce.
                    </p>

                    <div className="hero-buttons">
                        <button className="primary-btn" onClick={goToLogin}><FaRocket /> Get Started Free</button>
                        {/*<button className="secondary-btn"><FaPlay size={13} /> How It Works</button>*/}
                    </div>
                </div>

                <div className="hero-right"></div>
            </section>


            {/* ⭐ FEATURE CARDS SECTION */}
            <section className="features-section">
                <h2 className="features-title">Why Choose StrideNext?</h2>

                <div className="features-grid">

                    <div className="feature-card fade-up">
                        <FaUsers className="feature-icon" />
                        <h3>Student Growth</h3>
                        <p>Access opportunities, skill training, and real-world career paths.</p>
                    </div>

                    <div className="feature-card fade-up" style={{ animationDelay: ".2s" }}>
                        <FaBriefcase className="feature-icon" />
                        <h3>Employer Talent                       </h3>
                        <p>Discover top candidates with modern job-ready skillsets.</p>
                    </div>

                    <div className="feature-card fade-up" style={{ animationDelay: ".4s" }}>
                        <FaCertificate className="feature-icon" />
                        <h3>Trainer Empowerment</h3>
                        <p>Deliver training programs with integrated analytics and tools.</p>
                    </div>
                </div>
            </section>


            {/* FOOTER */}
            <footer className="footer fade-up">
                <div className="footer-top">
                    <h2 className="footer-title">Start Your Journey Today</h2>
                    <p className="footer-subtext">Join thousands of learners and employers shaping the future.</p>
                    <button className="footer-btn" onClick={goToLogin}>
                        Get Started <FaArrowRight />
                    </button>
                </div>

                <div className="footer-bottom">
                    <p>© 2025 StrideNext. All Rights Reserved.</p>
                </div>
            </footer>

        </div >

    );
};

export default LandingPage;
